/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import CSSModules from 'react-css-modules';
import { routerActions } from 'react-router-redux';
import { Table, Panel } from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import RichLabel from 'loracoms/RichLabel';
import Toolbar from 'loracoms/Toolbar';
import { getBills } from 'loraapi/Billing';
import styles from './styles/main.scss';

const propTypes = {
  intl: intlShape.isRequired,
  pushState: PropTypes.func.isRequired,
};

class BillLogs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.intlMsg = new IntlMsg(props.intl, 'billing');
  }

  componentDidMount() {
    this.loadBills();
  }

  loadBills(a) {
    const args = _.extend({
      from: this.state.from || moment().subtract(36, 'months'),
      to: this.state.to || moment(),
    }, a);

    let { from, to } = args;
    from = from.format('YYYYMM01');
    to = to.add(1, 'months').format('YYYYMM01');

    getBills(from, to).then((resp) => {
      const bills = resp.body.list.map((b) => {
        const price = _.round(b.price, 2);
        const charge = _.round(b.charge, 2);
        return { ...b, price, charge };
      });
      this.setState({ bills });
    }).catch(() => {});
  }

  renderToolbar() {
    const breadcrumb = [{
      content: this.intlMsg.msg('breadcrumb.billing'),
      onClick: () => this.props.pushState('/billing'),
    }, {
      content: this.intlMsg.msg('breadcrumb.billlogs'),
      active: true,
    }];
    return <Toolbar breadcrumb={breadcrumb} />;
  }

  renderBillsTable() {
    const { bills } = this.state;
    if (_.isNil(bills)) {
      return (
        <div styleName="table-loading">
          <i className="fa fa-spinner fa-spin fa-3x" aria-hidden="true" />
        </div>
      );
    }

    const rows = bills.map((b) => {
      let status = null;

      if (b.charge >= 0 && b.payment) {
        status = 'paid';
      } else {
        status = 'unpaid';
      }
      return (
        <tr key={b.id}>
          <td>{b.id}</td>
          <td>{b.period}</td>
          <td>
            <RichLabel
              content="nodefee"
              translateMap={{
                nodefee: this.intlMsg.msg('billlogs.table.feetypes.nodefee'),
              }}
            />
          </td>
          <td>¥{b.charge}</td>
          <td>
            <RichLabel
              content={status}
              translateMap={{
                paid: this.intlMsg.msg('billlogs.table.paystatus.paid'),
                unpaid: this.intlMsg.msg('billlogs.table.paystatus.unpaid'),
              }}
            />
          </td>
          <td>
            <a // eslint-disable-line
              onClick={() => this.props.pushState(`/billing/billdetail?id=${b.id}`)}
            >
              {this.intlMsg.msg('billlogs.table.detail.link')}
            </a>
          </td>
        </tr>
      );
    });

    return (
      <Table
        className="aisz-table-light"
        striped
        bordered
        hover
        responsive
      >
        <thead>
          <tr>
            <th>{ this.intlMsg.msg('billlogs.table.header.billno') }</th>
            <th>{ this.intlMsg.msg('billlogs.table.header.billperiod') }</th>
            <th>{ this.intlMsg.msg('billlogs.table.header.servicetype') }</th>
            <th>{ this.intlMsg.msg('billlogs.table.header.totalfee') }</th>
            <th>{ this.intlMsg.msg('billlogs.table.header.paystatus') }</th>
            <th>{ this.intlMsg.msg('billlogs.table.header.actions') }</th>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </Table>
    );
  }

  render() {
    return (
      <div styleName="wrapper">
        <div>
          { this.renderToolbar() }
        </div>
        <Panel bsStyle="aisz-white" header={this.intlMsg.msg('billlogs.panel.header')}>
          { this.renderBillsTable() }
        </Panel>
      </div>
    );
  }
}

BillLogs.propTypes = propTypes;

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(null,
  mapDispatchToProps,
  )(injectIntl(
    CSSModules(BillLogs, styles, { allowMultiple: true })));




// WEBPACK FOOTER //
// ./src/containers/Billing/BillLogs/index.jsx